import { render, staticRenderFns } from "./GestionAutorizaciones.vue?vue&type=template&id=20636fa8&scoped=true"
import script from "./GestionAutorizaciones.vue?vue&type=script&lang=js"
export * from "./GestionAutorizaciones.vue?vue&type=script&lang=js"
import style0 from "./GestionAutorizaciones.vue?vue&type=style&index=0&id=20636fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20636fa8",
  null
  
)

export default component.exports